module.exports = __webpack_public_path__ + "img/introducePageTwo_show_five.5692c3a1.jpg";